import React from 'react';
import {BackTop} from 'antd';
import {Link} from 'react-router-dom';
import Perfection from './Perfection.jsx';
export default function Footer() {


    return (
        <div className="footer">
            <div className="footer-basic">
                <div className="logo"></div>
                <dl className="enterprise">
                    <dt>北京搜知数据科技有限公司</dt>
                    <dd>电话：010-85786021-8001</dd>
                    <dd>传真：010-85786020</dd>
                    <dd>网址：www.sozdata.com</dd>
                    <dd>邮箱：service@epsnet.com.cn</dd>
                    <dd>地址：北京市海淀区知春路9号坤讯大厦3层303室</dd>
                </dl>
                <dl className="products">
                    <dt>产品中心</dt>
                    <dd><a href="http://olap.epsnet.com.cn/">EPS数据平台</a></dd>                              
                    <dd><a href="http://microdata.sozdata.com/">中国微观经济数据查询系统</a></dd>
                    <dd><a href="http://yreb.sozdata.com/">长江经济带大数据平台</a></dd>
                    <dd><a href="http://olap.epsnet.com.cn/">图情知识服务平台</a></dd>
                </dl>
                <dl className="app-download">
                    <dt>微信公众号</dt>
                    <dd></dd>
                </dl>
            </div>
            {/* <div className="bottom">
                <div className="inner">
                    <div className="nav">
                        <a href="/">联系我们</a><span>|</span> 
                        <a href="/">加入我们</a><span>|</span>  
                        <a href="/">在线留言</a><span>|</span>
                        <a href="/">帮助中心</a>
                    </div>
                    <div className="rights">京ICP备17041952号-2&nbsp;&nbsp;|&nbsp;&nbsp;Copyright&copy;{'2019'}&nbsp;北京搜知数据科技有限公司&nbsp;版权所有</div>
                </div>
            </div> */}
            <div className="foot_box">
                <div className="foot-logo cleft">
                <a href="http://www.sozdata.com/#/Index" target="_blank">
                    {/* <img src="/assets/sz-footer-logo-new.png" alt=""/> */}
                </a>
                </div>
                <div className="foot_item cleft">
                    <ul className="footlink">
                        <li><a href="http://www.sozdata.com/#/About" target="_blank">关于我们</a></li>
                        <li><a href="http://www.sozdata.com/#/Product?side=1" target="_blank">产品介绍</a></li>
                        <li><a href="http://www.sozdata.com/#/Service" target="_blank">项目服务</a></li>
                        <li><a href="http://www.sozdata.com/#/Customiz" target="_blank">数据定制</a></li>
                    </ul>
                </div>
                <div className="foot_group cright">
                    <ul className="footlink">                      
                        <li><span>Copyright&copy;2019 北京搜知数据科技有限公司 版权所有</span></li>
                        <li><span>京ICP备17041952号-2 京公网安备11010802029194</span></li>                       
                    </ul>
                </div>
            </div>
            
            <div className="urgent-service">                    
                <a target="_blank" rel="noopener noreferrer" href="http://chat10.live800.com/live800/chatClient/chatbox.jsp?companyID=448316&jid=6318557147&enterurl=http%3A%2F%2Fwww%2Eepsnet%2Ecom%2Ecn%2Fch%2FSys%2FReportPage%2Easpx%3FKey%3D230%26Type%3DKE%5FCLASS%5FEXPRESSREPORT&timestamp=1344843114447&pagereferrer=" title="在线客服">
                    <i className="ico ico-service"></i>
                    <div className="name">客服</div>
                </a>
            </div>
            <BackTop>
                <div className="backup" title="返回顶部"><i className="ico ico-up"></i></div>
            </BackTop>

            {/* <Perfection /> */}
        </div>
    );
}